import type { IconData } from '@stacksjs/iconify-core'

export const linkedinAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M5.004 7h-.029a2.235 2.235 0 1 1 .057-4.457A2.235 2.235 0 1 1 5.004 7m-1.986 3h4v12h-4zm14.5 0a4.47 4.47 0 0 0-3.5 1.703V10h-4v12h4v-5.5a2 2 0 0 1 4 0V22h4v-7.5a4.5 4.5 0 0 0-4.5-4.5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default linkedinAlt
